module.exports = __webpack_public_path__ + "static/media/ac_logo.fa31f1f6.svg";